import DebugTab from "slotworks/debug/menu/tabs/debug-tab";

export default class ForceTab extends DebugTab {

    public render(root: HTMLElement, hide: Function) {
        this.resultList.getList().then((list: string[]) => {
            this.addStopsForcer(root, hide);

            this.addSeparator(root);

            const header = document.createElement("h1");
            header.style.fontSize = "2vw";
            header.style.width = "76vw";
            header.style.color = "white";
            header.style.textAlign = "center";
            header.innerText = "Preset Forces";

            root.appendChild(header);

            // Add buttons
            for (const force of list) {
                this.addResultButton(root, hide, force);
            }
        });
    }

    private addStopsForcer(root: HTMLElement, hide: Function) {
        // Add input text
        const inputText = document.createElement("input");
        inputText.type = "text";
        inputText.style.fontSize = "3vw";
        inputText.style.margin = "1vmax 1vw";
        inputText.style.borderRadius = "10px";
        inputText.style.width = "35vw";
        inputText.style.height = "10vmax";
        inputText.style.backgroundColor = "#ffffff";

        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "35vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";
        inputBtn.innerText = "SET";

        inputBtn.onclick = () => {
            this.resultList.force(inputText.value).execute();
            hide();
        };

        root.appendChild(inputText);
        root.appendChild(inputBtn);
    }
}
